/* global window,document */
import React, {Component} from 'react';
import {render} from 'react-dom';
import MapGL from 'react-map-gl';
import DeckGLOverlay from './deckgl-overlay.js';

import {json as requestJson} from 'd3-request';

// Set your mapbox token here
const MAPBOX_TOKEN = "pk.eyJ1Ijoicm91dHJhaHVsIiwiYSI6ImNqMWxrZXQ2bjAwMnAyd21oMG9vdWVjangifQ.Iu_okW1LwhEBAWF7H7-L9Q";

// const MAPBOX_TOKEN = process.env.MAPBOX_ACCESS_TOKEN; // eslint-disable-line

var supplierNamesMapping={
  1:"Supplier - 1",
  2:"Supplier - 2",
  3:"Supplier - 3",
  4:"Supplier - 4"
  // 1:"Sams Club",
  // 2:"Wal-Mart China",
  // 3:"Wal-Mart Mexico",
  // 4:"Wal-Mart Argentina"
}

const inFlowColorsForTooltip = {
  0:{color:'rgb(127, 255, 212)'},
  1:{color:'rgb(124, 252, 0)'},
  2:{color:'rgb(127, 255, 212)'},
  3:{color:'rgb(0, 206, 209)'},
  4:{color:'rgb(255, 215, 0)'}
};

const supplierButtonSpecificColoursBackup = {
  0:{background:'rgb(127, 255, 212)'},
  1:{background:'rgb(124, 252, 0)'},
  2:{background:'rgb(127, 255, 212)'},
  3:{background:'rgb(0, 206, 209)'},
  4:{background:'rgb(255, 215, 0)'}
};

const supplierButtonSpecificColours = {
  0:{background:'rgb(127, 255, 212)'},
  1:{background:'rgb(124, 252, 0)'},
  2:{background:'rgb(127, 255, 212)'},
  3:{background:'rgb(0, 206, 209)'},
  4:{background:'rgb(255, 215, 0)'}
};

const tooltipStyle = {
  position: 'absolute',
  padding: '4px',
  background: '#a1a1a1',
  color: '#fff',
  maxWidth: '300px',
  fontSize: '12px',
  zIndex: 9,
  pointerEvents: 'none',
  opacity:'0.8',
  borderRadius:'10px'
};

const showCountry = {
  color: 'red',
  fontSize:'17px',
  textAlign:'center'
};


class Root extends Component {

  constructor(props) {
    super(props);
    this.state = {
      viewport: {
        ...DeckGLOverlay.defaultViewport,
        width: 500,
        height: 500
      },
      data: null,
      selectedCounty: props.data ? props.data[0] : null,
      imports:true,
      exports:true,
      suppliers:{
        1:true,
        2:true,
        3:true,
        4:true
      },
      supplierCheck:false,
      supplierButtonStyle:{
        borderRadius: '58px',
        fontFamily: 'Arial',
        color: '#ffffff',
        fontSize: '11px',
        padding: '8px 12px 8px 12px',
        cursor:'pointer',
        border:'1px solid #FFF',
        color:'#000',
        opacity:'0.5'
      },
      importsStyle:{
        borderRadius: '58px',
        fontFamily: 'Arial',
        color: '#ffffff',
        fontSize: '11px',
        background: '#d93434',
        padding: '8px 12px 8px 12px',
        cursor:'pointer',
        border:'1px solid #FFF'
      },
      exportsStyle:{
        borderRadius: '58px',
        fontFamily: 'Arial',
        color: '#ffffff',
        fontSize: '11px',
        background: '#34add9',
        padding: '8px 12px 8px 12px',
        cursor:'pointer',
        border:'1px solid #FFF'
      }
    };

    // requestJson('./data/counties.json', (error, response) => {
    // requestJson('./data/countries.json', (error, response) => {
    requestJson('./data/countries_supplier.json', (error, response) => {
      if (!error) {
        this.setState({
          data: response.features,
          selectedCounty: response.features.find(f => f.properties.name === 'United States')
        });
      }
    });
  }

  componentDidMount() {
    window.addEventListener('resize', this._resize.bind(this));
    this._resize();
  }

  _resize() {
    this._onChangeViewport({
      width: window.innerWidth,
      height: window.innerHeight
    });
  }

  _onHover({x, y, object}) {
    var element = null,active=null;
    if(undefined !== object){
      if(object.type === 'arc'){
        active = document.querySelector(".showCountry");
        if(null != active){
          active.classList.remove("showCountry");
          active.style.color="";
          active.style.background = "";
        }
        // console.log(object.sourceName,object.targetName,object.toId);
        element = document.getElementsByClassName("supplier_"+object.supplier+"_"+object.toId);
        element[0].className += " " + "showCountry";
        element[0].style.color = "red";
        element[0].style.background = "yellow";
      }
      // var obj = $(".supplier_"+object.supplier+"_"+object.toId);

    }

  }

  _onClick({x, y, object}) {
    this.setState({selectedCounty: object});
  }

  _onChangeViewport(viewport) {
    this.setState({
      viewport: {...this.state.viewport, ...viewport}
    });
  }

  _onMouseMove(evt) {
    if (evt.nativeEvent) {
      this.setState({mousePosition: [evt.nativeEvent.offsetX, evt.nativeEvent.offsetY]});
    }
  }


    _supplierOnOff(number){
      number = number.supplier_id;
      var obj = this.state.suppliers,changedSupplierVariable = !this.state.supplierCheck;
      if (!this.state.selectedCounty) {
        return null;
      }

      if(this.state.suppliers[number]){
        obj[number] = false;
        supplierButtonSpecificColours[number] = {backgound:"#c3c3c3"};
      }
      else {
        obj[number] = true;
        supplierButtonSpecificColours[number] = supplierButtonSpecificColoursBackup[number];
      }
      this.setState({
        suppliers:obj
      });
      this.setState({
        supplierCheck: changedSupplierVariable
      })
    }

    _selectImports(){
      if (!this.state.selectedCounty) {
        return null;
      }
      if(this.state.imports){
        this.setState({imports: false});
        this.setState({importsStyle:{
          borderRadius: '58px',
          fontFamily: 'Arial',
          color: '#ffffff',
          fontSize: '11px',
          background: '#c3c3c3',
          padding: '8px 12px 8px 12px',
          cursor:'pointer',
          border:'1px solid #FFF'
        }});
      }
      else {
        this.setState({imports: true});
        this.setState({importsStyle:{
          borderRadius: '58px',
          fontFamily: 'Arial',
          color: '#ffffff',
          fontSize: '11px',
          background: '#d93434',
          padding: '8px 12px 8px 12px',
          cursor:'pointer',
          border:'1px solid #FFF'
        }});
      }

      this._renderTooltip();
    }

    _selectExports(){
      if (!this.state.selectedCounty) {
        return null;
      }
      if(this.state.exports){
        this.setState({exports: false});
        this.setState({exportsStyle:{
          borderRadius: '58px',
          fontFamily: 'Arial',
          color: '#ffffff',
          fontSize: '11px',
          background: '#c3c3c3',
          padding: '8px 12px 8px 12px',
          cursor:'pointer',
          border:'1px solid #FFF'
        }});
      }
      else {
        this.setState({exports: true});
        this.setState({exportsStyle:{
          borderRadius: '58px',
          fontFamily: 'Arial',
          color: '#ffffff',
          fontSize: '11px',
          background: '#34add9',
          padding: '8px 12px 8px 12px',
          cursor:'pointer',
          border:'1px solid #FFF'
        }});
      }

      this._renderTooltip();
    }



  // _onMouseEnter() {
  //   this.setState({mouseEntered: true});
  // }
  //
  // _onMouseLeave() {
  //   this.setState({mouseEntered: false});
  // }


  _renderTooltip() {

    const {x, y, hoveredObject} = this.state;

    // const {id,index} = 0;
    if (!this.state.selectedCounty) {
      return null;
    }

    /**
    * This is kept for future purposes where styling of rows with supplier colour is kept
    <tr style={inFlowColorsForTooltip[supplier_id]} key={`${supplier_id} ${this.state.data[supp.to].properties.key} ${supp.to} ${index}`} className={`supplier_${supplier_id}_${supp.to}`}>
    **/

    var tableBody = [];
    Object.keys(this.state.selectedCounty.properties.supplier).map(
      (supplier_id,supp_index) =>
      this.state.selectedCounty.properties.supplier[supplier_id].map((supp,index) =>
      {
        if(this.state.suppliers[supplier_id]){
          if(this.state.imports && this.state.exports){
            tableBody.push(
            <tr key={`${supplier_id} ${this.state.data[supp.to].properties.key} ${supp.to} ${index}`} className={`supplier_${supplier_id}_${supp.to}`}>
              <td key={`${supplier_id} ${this.state.data[supp.to].properties.key} ${supp.to} ${index}`}>{supplierNamesMapping[supplier_id]}</td>
              <td key={`${supplier_id} ${this.state.data[supp.to].properties.key} ${index}`}>{this.state.data[supp.to].properties.name}</td>
              <td key={`${supplier_id} ${this.state.data[supp.to].properties.key} ${supp.to} ${supp.value} ${index}`}>{Math.abs(supp.value)}</td>
            </tr>)
          }
          else if (this.state.imports && !this.state.exports) {
            if(supp.value < 0){
              tableBody.push(
              <tr key={`${supplier_id} ${this.state.data[supp.to].properties.key} ${supp.to} ${index}`} className={`supplier_${supplier_id}_${supp.to}`}>
                <td key={`${supplier_id} ${this.state.data[supp.to].properties.key} ${supp.to} ${index}`}>{supplierNamesMapping[supplier_id]}</td>
                <td key={`${supplier_id} ${this.state.data[supp.to].properties.key} ${index}`}>{this.state.data[supp.to].properties.name}</td>
                <td key={`${supplier_id} ${this.state.data[supp.to].properties.key} ${supp.to} ${supp.value} ${index}`}>{Math.abs(supp.value)}</td>
              </tr>)
            }
          }
          else if (!this.state.imports && this.state.exports) {
            if(supp.value > 0){
              tableBody.push(
              <tr key={`${supplier_id} ${this.state.data[supp.to].properties.key} ${supp.to} ${index}`} className={`supplier_${supplier_id}_${supp.to}`}>
                <td key={`${supplier_id} ${this.state.data[supp.to].properties.key} ${supp.to} ${index}`}>{supplierNamesMapping[supplier_id]}</td>
                <td key={`${supplier_id} ${this.state.data[supp.to].properties.key} ${index}`}>{this.state.data[supp.to].properties.name}</td>
                <td key={`${supplier_id} ${this.state.data[supp.to].properties.key} ${supp.to} ${supp.value} ${index}`}>{Math.abs(supp.value)}</td>
              </tr>)
            }
          }
        }
      }
      )
    );

    // var supplierIdMap = null,supplierDataMap = null;
    // supplierIdMap = Object.keys(this.state.selectedCounty.properties.supplier).map((supplier_id,supp_index) => supplier_id);
    // supplierDataMap = supplierIdMap.map((suppData,suppDataIndex) => )
    return (
      <div style={{...tooltipStyle, right: 10, top: 25}}>
        <div><h4 style={showCountry}>{this.state.selectedCounty.properties.name}</h4></div>
        <table>
          <tbody>
            {tableBody}
          </tbody>
        </table>
      </div>
    );
  }



  render() {
    // const {viewport, data, selectedCounty} = this.state;
    const {viewport, data, mousePosition, mouseEntered,selectedCounty,imports,exports,importsStyle,exportsStyle,suppliers,supplierCheck,supplierButtonStyle} = this.state;

    return (
      <div>

        <div>
          <button onClick={this._selectImports.bind(this)} style={importsStyle}>Imports</button>
          <button onClick={this._selectExports.bind(this)} style={exportsStyle}>Exports</button>
          <div style={{marginTop:10, marginBottom:10}}>
              {Object.keys(this.state.suppliers).map(
                (supplier_id,supp_index) =>
                <button key={`${supplier_id} ${supp_index}`} onClick={this._supplierOnOff.bind(this,{supplier_id})}
                style={{ ...supplierButtonStyle, ...supplierButtonSpecificColours[supplier_id]}}>{supplierNamesMapping[supplier_id]}</button>
              )}
          </div>
          {this._renderTooltip()}
          <div>
            <MapGL
              {...viewport}
              mapStyle="mapbox://styles/mapbox/dark-v9"
              // mapStyle="mapbox://styles/mapbox/basic-v9"
              perspectiveEnabled={true}
              onChangeViewport={this._onChangeViewport.bind(this)}
              mapboxApiAccessToken={MAPBOX_TOKEN}
              >
              <DeckGLOverlay viewport={viewport}
                data={data}
                selectedFeature={selectedCounty}
                strokeWidth={2}
                mousePosition={mousePosition}
                mouseEntered={mouseEntered}
                onHover={this._onHover.bind(this)}
                onClick={this._onClick.bind(this)}
                selectedImports={imports}
                selectedExports={exports}
                passedSuppliers={suppliers}
                supplierChanged={supplierCheck}
                />
            </MapGL>
          </div>
        </div>
      </div>
    );
  }
}

render(<Root />, document.body.appendChild(document.createElement('div')));



// WEBPACK FOOTER //
// ./app.js